@if (!emptyValue) {
  <span (mouseenter)="mouseEnter()" (mouseleave)="mouseLeave()">
    @if (isLongValue()) {
      <span class="m-l-3" (click)="showValue()"><fa-icon icon="eye" size="sm" [title]="textValue"></fa-icon></span>
    }
    @if (isLongValue()) {
      <span class="m-l-5" (click)="showValue()">{{ textValue | truncateText: printChars }}...</span>
    }
    @if (!isLongValue()) {
      <span class="m-l-5" (click)="showValue()">{{ textValue }}</span>
    }
  </span>
}
